import { useEffect } from 'react'

// Sets a per-route <title>/meta description  this is a single-page React
// app, so without this every route would keep sharing the same generic
// title/description from public/index.html, giving Google nothing unique to
// show for a search like "gerador de cpf" pointing at that specific page.
export const useDocumentMeta = ({ title, description }) => {
  useEffect(() => {
    const previousTitle = document.title
    const descriptionTag = document.querySelector('meta[name="description"]')
    const previousDescription = descriptionTag
      ? descriptionTag.content
      : null

    if (title) document.title = title
    if (description && descriptionTag) {
      descriptionTag.content = description
    }

    return () => {
      document.title = previousTitle
      if (descriptionTag && previousDescription !== null) {
        descriptionTag.content = previousDescription
      }
    }
  }, [title, description])
}
